import { useEffect, useState } from 'react';
import { api } from '../services/api';
import { UI_CONTENT_FALLBACK, UI_CONTENT_KEYS } from './uiContentKeys';

export { UI_CONTENT_FALLBACK, UI_CONTENT_KEYS };

/**
 * Fetch one or more content keys. Returns the stored payload per key, falling
 * back to the seed above — never undefined, so a caller can render immediately.
 */
export function useUiContent(keys) {
  const wanted = Array.isArray(keys) ? keys : [keys];
  const joined = wanted.join(',');
  const [content, setContent] = useState(() =>
    Object.fromEntries(wanted.map((k) => [k, UI_CONTENT_FALLBACK[k]])));

  useEffect(() => {
    let cancelled = false;
    api.get(`/api/platform-definitions/ui-content/all?keys=${encodeURIComponent(joined)}`)
      .then(({ data }) => {
        if (cancelled) return;
        const fetched = data?.content || {};
        setContent(Object.fromEntries(joined.split(',').map((k) => [
          k,
          // An empty payload is treated as "not set" rather than "show nothing".
          (Array.isArray(fetched[k]) && fetched[k].length) || (fetched[k] && !Array.isArray(fetched[k]))
            ? fetched[k]
            : UI_CONTENT_FALLBACK[k],
        ])));
      })
      .catch(() => { /* the seed above is already in state */ });
    return () => { cancelled = true; };
  }, [joined]);

  return content;
}
